import React from 'react'
import { CircularProgress, Tooltip, Typography } from '@mui/material'
import clsx from 'clsx'
import useStyles from './_styles/PatientIdentityStatusStyles'
import { PatientIdentityStatusProps } from './_props'
import { getBackgroundColor, getIdentityStatusSlug, humanizePatientIdentityStatus } from './_utils/_utils'
import Tag from '../../../Common/Tag/Tag'
import { hexToRgba } from '../../../../utils/commonUtils'

const PatientIdentityStatus = ({ status, display = 'default', isLoading }: PatientIdentityStatusProps) => {
    const classes = useStyles()

    const statusSlug = React.useMemo(() => {
        if (!status) return undefined

        if (typeof status === 'string') {
            return status
        }

        return getIdentityStatusSlug(status?.code ?? undefined)
    }, [status])

    const label = React.useMemo(
        () => (statusSlug ? `Identité ${humanizePatientIdentityStatus(statusSlug)}` : undefined),
        [statusSlug],
    )

    if (!statusSlug) return null

    const backgroundColor = getBackgroundColor(statusSlug)

    if (isLoading) return <CircularProgress size="1.5rem" />

    if (display === 'dot')
        return (
            <Tooltip title={label}>
                <div className={classes.PatientIdentityStatusParent}>
                    <div
                        className={clsx(
                            classes.PatientIdentityStatus,
                            display === 'dot' && classes.PatientIdentityStatusDot,
                        )}
                        style={{
                            background: backgroundColor,
                        }}
                    />
                </div>
            </Tooltip>
        )

    if (display === 'tag')
        return (
            <Tag
                label={label ?? ''}
                background={backgroundColor ? hexToRgba(backgroundColor, 0.05) : undefined}
                color={backgroundColor}
            />
        )

    return (
        <div className={classes.PatientIdentityStatusContainer}>
            <div
                className={clsx(classes.PatientIdentityStatus)}
                style={{
                    background: backgroundColor,
                }}
            >
                <Typography className={classes.PatientIdentityStatusLabel}>{label}</Typography>
            </div>
        </div>
    )
}

export default PatientIdentityStatus
